<template>
  <div class="w-full h-full flex flex-col items-center bg-backgroundColor">
    <!-- Banner -->
    <BannerSection :banner="banner" :loading="loading" />

    <!-- About Section -->
    <div class="w-full h-full flex flex-col items-center">
      <div class="flex md:flex-row flex-col w-[94%] md:w-[75%] 2xl:w-[60%] pt-16">
        <div class="w-full md:w-1/2">
          <img
            class="w-full h-[420px] object-cover"
            :src="itemProfessional.imageUrl"
            alt=""
          />
        </div>
        <div class="w-full md:w-1/2 md:pl-5">
          <h2 class="pt-5 md:pt-0 text-3xl font-semibold text-mainColor">
            {{ itemProfessional.name }}
          </h2>
          <p class="pt-5 white-space text-justify">{{ itemProfessional.description }}</p>
          <p class="pt-5 white-space text-justify">{{ itemProfessional.description2 }}</p>
        </div>
      </div>
      <div class="w-[94%] md:w-[75%] 2xl:w-[60%] pt-5">
        <p class="white-space text-justify">{{ itemProfessional.description3 }}</p>   
      </div>
    </div>

    <!-- Items Section -->
    <div class="w-full h-full flex flex-col items-center">
      <div class="pt-12 w-[94%] md:w-[75%] 2xl:w-[60%]">
        <h2 class="text-3xl font-semibold text-mainColor">
          {{ section.name }}
        </h2>
        <div class="flex flex-col md:flex-row pt-4 gap-6">
          <div class="md:w-1/2 w-full grid grid-cols-2 gap-4">
            <div v-for="item in items" :key="item.id" class="flex items-center gap-4 p-4">
              <img v-if="item.icon" :src="item.icon" class="w-8 h-8 object-contain" />
              <span class="text-lg font-semibold">
                {{ item.name || "Untitled" }}
              </span>
            </div>
          </div>
          <div class="md:w-1/2 w-full">
            <img
              :src="section.imageUrl"
              alt=""
              class="w-full h-auto rounded-lg object-cover shadow"
            />
          </div>
        </div>
      </div>
    </div>
    <GuardingOurGuardContent />
    <GuardingWorkingShiftContent />
  </div>
</template>

<script>
import BannerSection from "@/components/BannerSection.vue";
import GuardingOurGuardContent from "@/components/OurService/GuardingOurGuardContent.vue";
import GuardingWorkingShiftContent from "@/components/OurService/GuardingWorkingShiftContent.vue";
import { db } from "@/firebaseConfig";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";

export default {
  name: "GuardingSecurityServicePage",
  components: { BannerSection, GuardingOurGuardContent, GuardingWorkingShiftContent },

  data() {
    return {
      banner: {},
      loading: true,
      items: [],
      itemProfessional: [],
      mainDocId: null,
      section: {
        name: "",
        icon: "",
      },
    };
  },

  async mounted() {
    await this.fetchBanner();
    await this.fetchItemProfessional(), await this.fetchMainDoc(); // this will load items afterwards
  },

  methods: {
    /* -----------------------
     * Fetch banner
     ------------------------ */
    async fetchBanner() {
      try {
        const snapshot = await getDocs(collection(db, "guardingBanner"));
        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          this.banner = { id: doc.id, ...doc.data() };
        }
      } catch (e) {
        console.error("Error fetching banner:", e);
      } finally {
        this.loading = false;
      }
    },

    /* -----------------------
     * Get main doc ID
     ------------------------ */
    async fetchMainDoc() {
      try {
        const snapshot = await getDocs(collection(db, "guardingKFS"));
        if (!snapshot.empty) {
          const docSnap = snapshot.docs[0];
          this.mainDocId = docSnap.id;

          const data = docSnap.data();
          this.section = {
            name: data?.name || "",
            icon: data?.icon || "",
            imageUrl: data?.imageUrl || null,
          };

          // fetch items AFTER mainDocId is ready
          await this.fetchItems();
        }
      } catch (e) {
        console.error("Error fetching mainDoc:", e);
      }
    },

    async fetchItemProfessional() {
      const q = query(
        collection(db, "professionalSecurityService"),
        orderBy("date", "asc"),
        limit(1)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const doc = snapshot.docs[0];
        this.itemProfessional = {
          id: doc.id,
          ...doc.data(),
        };
      } else {
        this.itemProfessional = null;
      }

      console.log(this.itemProfessional);
    },

    /* -----------------------
     * Get items list
     ------------------------ */
    async fetchItems() {
      if (!this.mainDocId) return;

      try {
        const q = query(
          collection(db, "guardingKFS", this.mainDocId, "items"),
          orderBy("orderNumber", "asc")
        );

        const snapshot = await getDocs(q);

        this.items = snapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            name: data?.name || "",
            icon: data?.icon || null,
            orderNumber: data?.orderNumber || 0,
          };
        });
      } catch (e) {
        console.error("Error fetching items:", e);
      }
    },
  },
};
</script>

<style scoped>
.white-space {
  white-space: pre-line;
}
</style>
